import React from 'react';
import Header from './Header';
import FooterOther from './FooterOther';
import saude_e_cuidado from '../assets/images/IMG_3934.png';

const womenHealthCareUnit = () => {
    return (
        <div>
            <Header />
            <img src={saude_e_cuidado} className="image-ajustada" style={{ width: '100%' }} alt="Saúde & Cuidado da Mulher" />
            <section className="request-proposal" id="solicitar-proposta">
                <div className="container-fluid">
                    <div className="row p-0 text-center">
                        <div className="col-12 title">Unidade de Saúde & Cuidado da Mulher</div>
                    </div>
                </div>
            </section>
            <section className="request-proposal-form" id="solicitar-proposta">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-12">
                            A unidade móvel de saúde e cuidado da mulher é uma solução prática e eficiente para atender às necessidades específicas de saúde feminina diretamente no local da sua empresa ou evento, com estrutura  completa e pronta para uso imediato.
                        </div>
                        <div className="col-12 py-3">
                            Essa solução elimina a necessidade de deslocamentos, facilitando o acesso a cuidados preventivos e diagnósticos que promovem o bem-estar e a qualidade de vida das mulheres. Flexíveis e personalizáveis, as unidades atendem empresas de diversos segmentos, garantindo cuidado especializado com agilidade e conforto.
                        </div>
                        <div className="col-12 py-3">
                            <strong>Exames e Serviços Disponíveis: </strong>
                        </div>
                        <div className="col-12 py-3">
                            <ul>
                                <li>Mamografia </li>
                                <li>Ultrassonografia </li>
                                <li>Papanicolau </li>
                                <li>Consulta Enfermagem </li>
                                <li>Consulta Ginecologista </li>
                            </ul>
                        </div>
                        <div className="col-12 py-3">
                            Seja para ações preventivas, diagnósticos rápidos ou campanhas de saúde, nossa unidade móvel é a escolha ideal para levar cuidado e atenção à saúde da mulher onde ela mais precisa.
                        </div>
                        <div className="col-3 py-2"> <a href="https://wa.me/556598106742" target="_blank" className="btn btn-warning text-uppercase d-block rounded-0 py-3"><strong>Quero Contratar</strong></a> </div>

                    </div>
                </div>
            </section>
            <FooterOther />
        </div>

    );
};

export default womenHealthCareUnit;